namespace Nobox.Nobox.Pages {
    export interface FormUploadFileResponse {
        IsError?: boolean;
        Error?: string;
        Data?: Web.Hubs.UploadedFileCustom;
    }
}
